import { render, staticRenderFns } from "./OtherGemstoneReport1024.vue?vue&type=template&id=4b5ee62e&scoped=true"
import script from "./OtherGemstoneReport1024.vue?vue&type=script&lang=js"
export * from "./OtherGemstoneReport1024.vue?vue&type=script&lang=js"
import style0 from "./OtherGemstoneReport1024.vue?vue&type=style&index=0&id=4b5ee62e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ee62e",
  null
  
)

export default component.exports